// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function reportClass(t) {
  return t.reportClass;
}

function enabled(t) {
  return t.enabled;
}

function settings(t) {
  return t.settings;
}

function empty(param) {
  return {
          id: 0,
          name: "",
          reportClass: "",
          enabled: false,
          settings: {}
        };
}

function decode(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("report_name", Json_decode.string, json),
          reportClass: Json_decode.field("report_class", Json_decode.string, json),
          enabled: Json_decode.field("enabled", Json_decode.bool, json),
          settings: Json_decode.field("settings", (function (param) {
                  return Json_decode.dict(Json_decode.string, param);
                }), json)
        };
}

exports.id = id;
exports.name = name;
exports.reportClass = reportClass;
exports.enabled = enabled;
exports.settings = settings;
exports.empty = empty;
exports.decode = decode;
/* No side effect */
